export const animLayoutLoad = {
    to: {
        opacity: 1,
        x: 0
    },
    from: {
        opacity: 0,
        x: 10
    }
}

export const animPageLoad = {
    to: {
        opacity: 1,
    },
    from: {
        opacity: 0,
    },
    config: {
        tension: 80
    }
}